import axios, { AxiosResponse } from "axios";
import {AddCmsRoleData, IUser, UserList} from "./admin-users.type";

/**
 * Список пользователей
 */
export const getUsers = (params: any): Promise<AxiosResponse<UserList>> => {
    return axios.get<UserList>(`/services/isnaportal/management/api/user`, {params});
};

/**
 * Создание пользователя
 */
export const createUser = (data: any): Promise<AxiosResponse<void>> => {
    return axios.post<void>(`/services/isnaportal/management/api/user`, data);
};

/**
 * Удаление пользователя
 */
export const deleteUser = (id: number): Promise<AxiosResponse<void>> => {
    return axios.delete<void>(`/services/isnaportal/management/api/user/${id}`);
};

/**
 * Удаление пользователя навсегда
 */
export const hardDeleteUser = (id: number): Promise<AxiosResponse<void>> => {
    return axios.delete<void>(
        `/services/isnaportal/management/api/user/${id}/hard-delete`
    );
};

/**
 * Получение пользователя по id
 */
export const getUserById = (id: number): Promise<AxiosResponse<IUser>> => {
    return axios.get<IUser>(`/services/isnaportal/management/api/user/${id}`);
};

/**
 * Изменение ролей у пользователей
 */
export const changeRoles = (userId: number, data: any): Promise<AxiosResponse<void>> => {
    return axios.post<void>(`/services/isnaportal/management/api/user/${userId}/change-role`, data);
};

/**
 * Изменение ролей у пользователей в cms
 */
export const changeCmsRoles = (serviceUrl: string, data: AddCmsRoleData): Promise<AxiosResponse<void>> => {
    return axios.post<void>(serviceUrl, data);
};

/**
 * Удаление пользователя из cms
 * @param data
 * @param serviceUrl
 */
export const removeCmsUser = (serviceUrl: string, data: any): Promise<AxiosResponse> => {
    return axios.post(serviceUrl, data);
};

/**
 * Список удаленных пользователей
 */
export const getDeletedUsers = (params: any): Promise<AxiosResponse<UserList>> => {
    return axios.get<UserList>(`/services/isnaportal/management/api/user/deleted`, {params});
};

/**
 * Восстановление удаленного пользователя
 */
export const restoreDeletedUser = (id: number): Promise<AxiosResponse<IUser[]>> => {
    return axios.post<IUser[]>(`/services/isnaportal/management/api/user/${id}/restore`);
};


// Роли

/**
 * Список ролей
 */
export const getRoleList = (): Promise<AxiosResponse<any>> => {
    return axios.get<any>(`/services/isnaportal/api/roles`);
};

/**
 * Создание роли
 */
export const addRole = (data: any): Promise<AxiosResponse<any>> => {
    return axios.post<any>(`/services/isnaportal/api/roles`, data);
};

/**
 * Создание роли c CMS
 */
export const addRoleWithCms = (serviceUrl: string, data: any): Promise<AxiosResponse<any>> => {
    return axios.post<any>(serviceUrl, data);
};

/**
 * Удаление роли
 */
export const deleteRole = (id): Promise<AxiosResponse<any>> => {
    return axios.delete<any>(`/services/isnaportal/api/roles/${id}`);
};

/**
 * Удаление роли c CMS
 */
export const deleteRoleWithCms = (serviceUrl, id): Promise<AxiosResponse<any>> => {
    return axios.delete<any>(serviceUrl, {
        params: { id }
    });
};

/**
 * Получение роли по id
 */
export const findById = (id): Promise<AxiosResponse<any>> => {
    return axios.get<any>(`/services/isnaportal/api/roles/${id}`);
};

/**
 * Редактирование роли по id
 */
export const editRole = (data, id): Promise<AxiosResponse<any>> => {
    return axios.put<any>(`/services/isnaportal/api/roles/${id}/name`, data);
};

/**
 * Редактирование роли по id с CMS
 */
export const editRoleWithCms = (serviceUrl: string, data: any): Promise<AxiosResponse<any>> => {
    return axios.put<any>(serviceUrl, data);
};

/**
 * Получение списка ролей пользователя
 */
export const findAllByUserId = (userId: number): Promise<AxiosResponse<any>> => {
    return axios.get<any>(`/services/isnaportal/api/roles/users/${userId}`);
};

/**
 * Обновление списка ролей пользователя
 */
export const updateUserRoles = (roleIds: any, userId: number): Promise<AxiosResponse<any>> => {
    return axios.put<any>(`/services/isnaportal/api/roles/users/${userId}`, {}, {
        params: { roleIds: roleIds.join(',') }
    });
};

/**
 * Получение списка прав у пользователя
 */
export const findAllPrivilegesByUserId = (userId: number): Promise<AxiosResponse<any>> => {
    return axios.get<any>(`/services/isnaportal/api/roles/users/${userId}/privileges`);
};


/**
 * Редактирование прав у роли
 */
export const editRolePermissions = (privilegeIds, roleId): Promise<AxiosResponse<any>> => {
    return axios.put<any>(`/services/isnaportal/api/roles/${roleId}/privileges`, {}, {
        params: { privilegeIds: privilegeIds.join(',') }
    });
};

/**
 * Получение списка прав и ролей
 */
export const getPrivileges = (): Promise<AxiosResponse<any>> => {
    return axios.get<any>(`/services/isnaportal/api/privileges`);
};
